import { enableHotspotIcon } from '../state/ui-store';

export const enableHotspotBttn = () => enableHotspotIcon();
